<template>
        <a
          class="link-green"
          :href="`/Saul-Verde_UX-Product-design_${String($i18n.locale)}.pdf`"
          target="_blank"
          role="button"
          >
          {{ t(`resume.${String($i18n.locale)}`) }}
          </a
        >
</template>

<script>
import {useI18n} from 'vue-i18n';
export default {
  name: "NavLinks",
  components: {

  },
  setup() {
    const {t} = useI18n(); 
    return {t};
  }
};
</script>
